import { render } from "./Index.vue?vue&type=template&id=173afea2&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=173afea2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173afea2"],['__file',"components/Pages/Booking/Approval/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "173afea2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('173afea2', __exports__)) {
    api.reload('173afea2', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=173afea2&scoped=true", () => {
    api.rerender('173afea2', render)
  })

}


export default __exports__